import type { Item, ItemSet } from '../types';
import { effects } from './effects';

const effectsById = Object.fromEntries(effects.map(e => [e.id, e]));

const trollSet: ItemSet = {
  name: 'troll',
  items: [],
  bonus: [
    undefined,
    undefined,
    undefined,
    effectsById.SetEffect_TrollArmor,
  ],
};

const berserkerSet: ItemSet = {
  name: 'berserker',
  items: [],
  bonus: [
    undefined,
    undefined,
    effectsById.SetEffect_BerserkerArmor,
  ],
};

const berserkerUndeadSet: ItemSet = {
  name: 'berserker',
  items: [],
  bonus: [
    undefined,
    undefined,
    effectsById.SetEffect_BerserkerUndeadArmor,
  ],
};

const harvesterSet: ItemSet = {
  name: 'harvester',
  items: [],
  bonus: [
    undefined,
    undefined,
    effectsById.SetEffect_HarvesterArmor,
  ],
};

const rootSet: ItemSet = {
  name: 'root',
  items: [],
  bonus: [
    undefined,
    undefined,
    effectsById.SetEffect_RootArmor,
  ],
};

const fenringSet: ItemSet = {
  name: 'fenring',
  items: [],
  bonus: [
    undefined,
    undefined,
    effectsById.SetEffect_FenringArmor,
  ],
};

const asksvinSet: ItemSet = {
  name: 'asksvin',
  items: [],
  bonus: [
    undefined,
    undefined,
    effectsById.SetEffect_AshlandsMediumArmor,
  ],
};

const hideHair = true;
const hideBeard = true;

export const items: Item[] = [
// PRE-CRAFT AGE
  {
    id: 'ArmorRagsLegs',
    tier: 0,
    type: 'armor', slot: 'legs',
    armor: [1, 1],
    weight: 2,
    maxLvl: 2,
    durability: [200, 50],
    moveSpeed: 0,
  },
  {
    id: 'ArmorRagsChest',
    tier: 0,
    type: 'armor', slot: 'body',
    armor: [1, 1],
    weight: 2,
    maxLvl: 2,
    durability: [200, 50],
    moveSpeed: 0,
  },
// STONE AGE
  {
    id: 'ArmorLeatherLegs',
    tier: 1,
    type: 'armor', slot: 'legs',
    armor: [2, 2],
    weight: 5,
    maxLvl: 4,
    durability: [400, 100],
    moveSpeed: 0,
  },
  {
    id: 'ArmorLeatherChest',
    tier: 1,
    type: 'armor', slot: 'body',
    armor: [2, 2],
    weight: 1,
    maxLvl: 4,
    durability: [400, 100],
    moveSpeed: 0,
  },
  {
    id: 'HelmetLeather',
    tier: 1,
    type: 'armor', slot: 'head',
    hideHair,
    armor: [2, 2],
    weight: 1,
    maxLvl: 4,
    durability: [400, 100],
    moveSpeed: 0,
  },
  {
    id: 'CapeDeerHide',
    tier: 1,
    type: 'armor', slot: 'shoulders',
    armor: [1, 1],
    weight: 4,
    maxLvl: 4,
    durability: [400, 50],
    moveSpeed: 0,
  },
  // decorative dresses
  ...[2, 4, 5, 2, 4, 5, 2, 4, 5, 1].map<Item>((tier, i) => (
    {
      id: `ArmorDress${i + 1}`,
      tier,
      type: 'armor', slot: 'body',
      armor: [1, 1],
      weight: 10,
      maxLvl: 4,
      durability: [1000, 200],
      staminaModifiers: { home: -0.2 },
      moveSpeed: 0,
    }
  )),
  ...[2, 4, 5, 2, 4, 5, 2, 4, 5, 1].map<Item>((tier, i) => (
    {
      id: `ArmorTunic${i + 1}`,
      tier,
      type: 'armor', slot: 'shoulders',
      armor: [1, 1],
      weight: 10,
      maxLvl: 4,
      durability: [1000, 200],
      staminaModifiers: { home: -0.2 },
      moveSpeed: 0,
    }
  )),
  ...[2, 4, 2, 4, 1, 4, 5, 5, 5, 1].map<Item>((tier, i) => (
    {
      id: `HelmetHat${i + 1}`,
      tier,
      type: 'armor', slot: 'head',
      armor: [1, 2],
      weight: 3,
      maxLvl: 4,
      durability: [800, 100],
      staminaModifiers: { home: -0.15 },
      moveSpeed: 0,
    }
  )),
  {
    id: 'ArmorHarvester1', // itemType: 7
    tier: 3,
    type: 'armor', slot: 'body',
    set: harvesterSet,
    armor: [1, 1],
    weight: 10,
    maxLvl: 4,
    durability: [1000, 200],
    staminaModifiers: { home: -0.2 },
    moveSpeed: 0,
  },
  {
    id: 'ArmorHarvester2', // itemType: 7
    tier: 3,
    type: 'armor', slot: 'body',
    set: harvesterSet,
    armor: [1, 1],
    weight: 10,
    maxLvl: 4,
    durability: [1000, 200],
    staminaModifiers: { home: -0.2 },
    moveSpeed: 0,
  },
  {
    id: 'HelmetStrawHat', // itemType: 6
    tier: 3,
    type: 'armor', slot: 'head',
    set: harvesterSet,
    armor: [1, 2],
    weight: 3,
    maxLvl: 4,
    durability: [800, 100],
    moveSpeed: 0,
  },
  // troll
  { id: 'ArmorTrollLeatherLegs',
    tier: 1,
    type: 'armor', slot: 'legs',
    set: trollSet,
    armor: [6, 2],
    weight: 5,
    maxLvl: 4,
    durability: [500, 200],
    moveSpeed: 0,
  },
  {
    id: 'ArmorTrollLeatherChest',
    tier: 1,
    type: 'armor', slot: 'body',
    set: trollSet,
    armor: [6, 2],
    weight: 5,
    maxLvl: 4,
    durability: [500, 200],
    moveSpeed: 0,
  },
  {
    id: 'HelmetTrollLeather',
    tier: 1,
    type: 'armor', slot: 'head',
    hideHair,
    set: trollSet,
    armor: [6, 2],
    weight: 1,
    maxLvl: 4,
    durability: [500, 200],
    moveSpeed: 0,
  },
  {
    id: 'CapeTrollHide',
    tier: 1,
    type: 'armor', slot: 'shoulders',
    set: trollSet,
    armor: [1, 1],
    weight: 4,
    maxLvl: 4,
    durability: [500, 50],
    moveSpeed: 0,
  },
  // bear / berserk
  {
    id: 'ArmorBerserkerLegs',
    tier: 2,
    type: 'armor', slot: 'legs',
    set: berserkerSet,
    armor: [7, 2],
    weight: 5,
    maxLvl: 4,
    durability: [1000, 200],
    moveSpeed: 0,
  },
  {
    id: 'ArmorBerserkerChest',
    tier: 2,
    type: 'armor', slot: 'body',
    set: berserkerSet,
    armor: [7, 2],
    weight: 5,
    maxLvl: 4,
    durability: [1000, 200],
    moveSpeed: 0,
  },
  {
    id: 'HelmetBerserkerHood',
    tier: 2,
    type: 'armor', slot: 'head',
    set: berserkerSet,
    armor: [7, 2],
    weight: 1,
    maxLvl: 4,
    durability: [1000, 200],
    moveSpeed: 0,
  },
  {
    id: 'HelmetCelebration',
    tier: 2,
    type: 'armor', slot: 'head',
    armor: [1, 2],
    weight: 3,
    maxLvl: 4,
    durability: [800, 100],
    moveSpeed: 0,
  },
// BRONZE AGE
  { id: 'ArmorBronzeLegs',
    tier: 2,
    type: 'armor', slot: 'legs',
    armor: [8, 2],
    weight: 5,
    maxLvl: 4,
    durability: [1000, 200],
    moveSpeed: -0.05,
  },
  {
    id: 'ArmorBronzeChest',
    tier: 2,
    type: 'armor', slot: 'body',
    armor: [8, 2],
    weight: 10,
    maxLvl: 4,
    durability: [1000, 200],
    moveSpeed: -0.05,
  },
  {
    id: 'HelmetBronze',
    tier: 2,
    type: 'armor', slot: 'head',
    hideHair,
    armor: [8, 2],
    weight: 3,
    maxLvl: 4,
    durability: [1000, 200],
    moveSpeed: 0,
  },
  {
    id: 'TrinketBronzeHealth',
    tier: 2,
    type: 'armor', slot: 'trinket',
    armor: [0, 0],
    weight: 2,
    maxLvl: 1,
    durability: [Infinity, 0],
    moveSpeed: 0,
    adrenaline: {
      max: 50,
      effect: effectsById.TrinketBronzeHealth!,
    },
  },
  {
    id: 'TrinketBronzeStamina',
    tier: 2,
    type: 'armor', slot: 'trinket',
    armor: [0, 0],
    weight: 2,
    maxLvl: 1,
    durability: [Infinity, 0],
    moveSpeed: 0,
    adrenaline: {
      max: 50,
      effect: effectsById.TrinketBronzeStamina!,
    },
  },
  {
    id: 'TrinketChitinSwim',
    tier: 2,
    type: 'armor', slot: 'trinket',
    armor: [0, 0],
    weight: 2,
    maxLvl: 1,
    durability: [Infinity, 0],
    moveSpeed: 0,
    adrenaline: {
      max: 10,
      effect: effectsById.TrinketChitinSwim!,
    },
  },
// IRON AGE
  {
    id: 'ArmorRootLegs',
    tier: 3,
    type: 'armor', slot: 'legs',
    set: rootSet,
    armor: [8, 2],
    weight: 10,
    maxLvl: 4,
    durability: [800, 100],
    moveSpeed: -0.02,
    damageModifiers: { fire: 'weak' },
  },
  {
    id: 'ArmorRootChest',
    tier: 3,
    type: 'armor', slot: 'body',
    set: rootSet,
    armor: [8, 2],
    weight: 10,
    maxLvl: 4,
    durability: [800, 100],
    moveSpeed: -0.02,
    damageModifiers: { fire: 'weak', pierce: 'resistant' },
  },
  {
    id: 'HelmetRoot',
    tier: 3,
    type: 'armor', slot: 'head',
    hideHair,
    hideBeard,
    set: rootSet,
    armor: [8, 2],
    weight: 3,
    maxLvl: 4,
    durability: [800, 100],
    moveSpeed: 0,
    damageModifiers: { fire: 'weak', poison: 'resistant' },
  },
  {
    id: 'ArmorIronLegs',
    tier: 3,
    type: 'armor', slot: 'legs',
    armor: [14, 2],
    weight: 15,
    maxLvl: 4,
    durability: [1000, 200],
    moveSpeed: -0.05,
  },
  {
    id: 'ArmorIronChest',
    tier: 3,
    type: 'armor', slot: 'body',
    armor: [14, 2],
    weight: 15,
    maxLvl: 4,
    durability: [1000, 200],
    moveSpeed: -0.05,
  },
  {
    id: 'HelmetIron',
    tier: 3,
    type: 'armor', slot: 'head',
    hideHair,
    armor: [14, 2],
    weight: 3,
    maxLvl: 4,
    durability: [1000, 200],
    moveSpeed: 0,
  },
  {
    id: 'TrinketIronHealth',
    tier: 3,
    type: 'armor', slot: 'trinket',
    armor: [0, 0],
    weight: 2,
    maxLvl: 1,
    durability: [Infinity, 0],
    moveSpeed: 0,
    adrenaline: {
      max: 65,
      effect: effectsById.TrinketIronHealth!,
    },
  },
  {
    id: 'TrinketIronStamina',
    tier: 3,
    type: 'armor', slot: 'trinket',
    armor: [0, 0],
    weight: 2,
    maxLvl: 1,
    durability: [Infinity, 0],
    moveSpeed: 0,
    adrenaline: {
      max: 60,
      effect: effectsById.TrinketIronStamina!,
    },
  },
// SILVER AGE
  {
    id: 'ArmorFenringLegs',
    tier: 3,
    type: 'armor', slot: 'legs',
    set: fenringSet,
    armor: [10, 2],
    weight: 10,
    maxLvl: 4,
    durability: [1000, 200],
    moveSpeed: 0.03,
  },
  {
    id: 'ArmorFenringChest',
    tier: 3,
    type: 'armor', slot: 'body',
    set: fenringSet,
    armor: [10, 2],
    weight: 10,
    maxLvl: 4,
    durability: [1000, 200],
    moveSpeed: 0.03,
    damageModifiers: { frost: 'resistant' },
  },
  {
    id: 'HelmetFenring',
    tier: 3,
    type: 'armor', slot: 'head',
    hideHair,
    hideBeard,
    set: fenringSet,
    armor: [10, 2],
    weight: 3,
    maxLvl: 4,
    durability: [1000, 200],
    moveSpeed: 0.03,
  },
  {
    id: 'ArmorWolfLegs',
    tier: 4,
    type: 'armor', slot: 'legs',
    armor: [20, 2],
    weight: 15,
    maxLvl: 4,
    durability: [1000, 200],
    moveSpeed: -0.05,
  },
  {
    id: 'ArmorWolfChest',
    tier: 4,
    type: 'armor', slot: 'body',
    armor: [20, 2],
    weight: 15,
    maxLvl: 4,
    durability: [1000, 200],
    moveSpeed: -0.05,
    damageModifiers: { frost: 'resistant' },
  },
  {
    id: 'HelmetDrake',
    tier: 4,
    type: 'armor', slot: 'head',
    hideHair,
    armor: [20, 2],
    weight: 3,
    maxLvl: 4,
    durability: [1000, 200],
    moveSpeed: 0,
  },
  {
    id: 'CapeWolf',
    tier: 4,
    type: 'armor', slot: 'shoulders',
    armor: [1, 1],
    weight: 4,
    maxLvl: 4,
    durability: [1000, 50],
    moveSpeed: 0,
    damageModifiers: { frost: 'resistant' },
  },
  {
    id: 'TrinketSilverDamage',
    tier: 4,
    type: 'armor', slot: 'trinket',
    armor: [0, 0],
    weight: 2,
    maxLvl: 1,
    durability: [Infinity, 0],
    moveSpeed: 0,
    adrenaline: {
      max: 55,
      effect: effectsById.TrinketSilverDamage!,
    },
  },
  {
    id: 'TrinketSilverResist',
    tier: 4,
    type: 'armor', slot: 'trinket',
    armor: [0, 0],
    weight: 2,
    maxLvl: 1,
    durability: [Infinity, 0],
    moveSpeed: 0,
    adrenaline: {
      max: 80,
      effect: effectsById.TrinketSilverResist!,
    },
  },
// BLACK AGE
  {
    id: 'ArmorBerserkerUndeadLegs',
    tier: 5,
    type: 'armor', slot: 'legs',
    set: berserkerUndeadSet,
    armor: [18, 2],
    weight: 5,
    maxLvl: 4,
    durability: [1000, 200],
    moveSpeed: 0,
  },
  {
    id: 'ArmorBerserkerUndeadChest',
    tier: 5,
    type: 'armor', slot: 'body',
    set: berserkerUndeadSet,
    armor: [18, 2],
    weight: 5,
    maxLvl: 4,
    durability: [1000, 200],
    moveSpeed: 0,
  },
  {
    id: 'HelmetBerserkerUndead',
    tier: 5,
    type: 'armor', slot: 'head',
    set: berserkerUndeadSet,
    armor: [12, 2],
    weight: 1,
    maxLvl: 4,
    durability: [1000, 200],
    moveSpeed: 0,
  },
  {
    id: 'ArmorPaddedGreaves',
    tier: 5,
    type: 'armor', slot: 'legs',
    armor: [26, 2],
    weight: 10,
    maxLvl: 4,
    durability: [1000, 200],
    moveSpeed: -0.05,
  },
  {
    id: 'ArmorPaddedCuirass',
    tier: 5,
    type: 'armor', slot: 'body',
    armor: [26, 2],
    weight: 10,
    maxLvl: 4,
    durability: [1000, 200],
    moveSpeed: -0.05,
  },
  {
    id: 'HelmetPadded',
    tier: 5,
    type: 'armor', slot: 'head',
    hideHair,
    armor: [26, 2],
    weight: 3,
    maxLvl: 4,
    durability: [1000, 200],
    moveSpeed: 0,
  },
  {
    id: 'CapeLinen',
    tier: 5,
    type: 'armor', slot: 'shoulders',
    variants: 5,
    armor: [1, 1],
    weight: 4,
    maxLvl: 4,
    durability: [1500, 50],
    moveSpeed: 0,
  },
  {
    id: 'CapeLox',
    tier: 5,
    type: 'armor', slot: 'shoulders',
    armor: [1, 1],
    weight: 4,
    maxLvl: 4,
    durability: [1200, 50],
    moveSpeed: 0,
    damageModifiers: { frost: 'resistant' },
  },
  {
    id: 'TrinketBlackDamageHealth',
    tier: 5,
    type: 'armor', slot: 'trinket',
    armor: [0, 0],
    weight: 2,
    maxLvl: 1,
    durability: [Infinity, 0],
    moveSpeed: 0,
    adrenaline: {
      max: 85,
      effect: effectsById.TrinketBlackDamageHealth!,
    },
  },
  {
    id: 'TrinketBlackStamina',
    tier: 5,
    type: 'armor', slot: 'trinket',
    armor: [0, 0],
    weight: 2,
    maxLvl: 1,
    durability: [Infinity, 0],
    moveSpeed: 0,
    adrenaline: {
      max: 60,
      effect: effectsById.TrinketBlackStamina!,
    },
  },
  // MIST AGE
  {
    id: 'ArmorCarapaceLegs',
    tier: 6,
    type: 'armor', slot: 'legs',
    armor: [32, 2],
    weight: 10,
    maxLvl: 4,
    durability: [1000, 200],
    moveSpeed: -0.05,
  },
  { 
    id: 'ArmorCarapaceChest',
    tier: 6,
    type: 'armor', slot: 'body',
    armor: [32, 2],
    weight: 10,
    maxLvl: 4,
    durability: [1000, 200],
    moveSpeed: -0.05,
  },
  {
    id: 'HelmetCarapace',
    tier: 6,
    type: 'armor', slot: 'head',
    hideHair,
    armor: [32, 2],
    weight: 3,
    maxLvl: 4,
    durability: [1000, 200],
    moveSpeed: 0,
  },
  {
    id: 'ArmorMageLegs',
    tier: 6,
    type: 'armor', slot: 'legs',
    armor: [16, 2],
    weight: 5,
    maxLvl: 4,
    durability: [500, 200],
    moveSpeed: -0.02,
    eitrRegen: 0.4,
  },
  {
    id: 'ArmorMageChest',
    tier: 6,
    type: 'armor', slot: 'body',
    armor: [16, 2],
    weight: 10,
    maxLvl: 4,
    durability: [500, 200],
    moveSpeed: -0.02,
    eitrRegen: 0.4,
  },
  {
    id: 'HelmetMage',
    tier: 6,
    type: 'armor', slot: 'head',
    hideHair,
    armor: [16, 2],
    weight: 1,
    maxLvl: 4,
    durability: [500, 200],
    moveSpeed: 0,
    eitrRegen: 0.2,
  },
  {
    id: 'CapeFeather',
    tier: 6,
    type: 'armor', slot: 'shoulders',
    armor: [1, 1],
    weight: 4,
    maxLvl: 4,
    damageModifiers: { frost: 'resistant' },
    durability: [1200, 50],
    moveSpeed: 0,
    effect: effectsById.SlowFall,
  },
  {
    id: 'TrinketCarapaceEitr',
    tier: 6,
    type: 'armor', slot: 'trinket',
    armor: [0, 0],
    weight: 2,
    maxLvl: 1,
    durability: [Infinity, 0],
    moveSpeed: 0,
    adrenaline: {
      max: 65,
      effect: effectsById.TrinketCarapaceEitr!,
    },
  },
  {
    id: 'TrinketScaleStaminaDamage',
    tier: 6,
    type: 'armor', slot: 'trinket',
    armor: [0, 0],
    weight: 2,
    maxLvl: 1,
    durability: [Infinity, 0],
    moveSpeed: 0,
    adrenaline: {
      max: 75,
      effect: effectsById.TrinketScaleStaminaDamage!,
    },
  },
  // ASH AGE
  {
    id: 'ArmorFlametalLegs',
    tier: 1,
    type: 'armor', slot: 'legs',
    armor: [38, 2],
    weight: 10,
    maxLvl: 4,
    durability: [1000, 200],
    moveSpeed: -0.05,
    // heatModifier: 0.2,
  },
  {
    id: 'ArmorFlametalChest',
    tier: 1,
    type: 'armor', slot: 'body',
    armor: [38, 2],
    weight: 1,
    maxLvl: 4,
    durability: [1000, 200],
    moveSpeed: -0.05,
    // heatModifier: 0.2,
  },
  {
    id: 'HelmetFlametal',
    tier: 1,
    type: 'armor', slot: 'head',
    hideHair,
    armor: [38, 2],
    weight: 1,
    maxLvl: 4,
    durability: [800, 100],
    moveSpeed: 0,
  },

  {
    id: 'ArmorAshlandsMediumlegs',
    tier: 1,
    type: 'armor', slot: 'legs',
    set: asksvinSet,
    armor: [28, 2],
    weight: 10,
    maxLvl: 4,
    durability: [1000, 200],
    moveSpeed: 0,
  },
  {
    id: 'ArmorAshlandsMediumChest',
    tier: 1,
    type: 'armor', slot: 'body',
    set: asksvinSet,
    armor: [28, 2],
    weight: 1,
    maxLvl: 4,
    durability: [1000, 200],
    moveSpeed: 0,
  },
  {
    id: 'HelmetAshlandsMediumHood',
    tier: 1,
    type: 'armor', slot: 'head',
    set: asksvinSet,
    hideHair,
    armor: [28, 2],
    weight: 1,
    maxLvl: 4,
    durability: [1000, 200],
    moveSpeed: 0,
  },

  {
    id: 'ArmorMageLegs_Ashlands',
    tier: 1,
    type: 'armor', slot: 'legs',
    armor: [19, 2],
    weight: 5,
    maxLvl: 4,
    durability: [1000, 200],
    moveSpeed: -0.02,
    eitrRegen: 0.5,
  },
  {
    id: 'ArmorMageChest_Ashlands',
    tier: 1,
    type: 'armor', slot: 'body',
    armor: [19, 2],
    weight: 1,
    maxLvl: 4,
    durability: [1000, 200],
    moveSpeed: -0.02,
    eitrRegen: 0.5,
  },
  {
    id: 'HelmetMage_Ashlands',
    tier: 1,
    type: 'armor', slot: 'head',
    hideHair,
    armor: [19, 2],
    weight: 1,
    maxLvl: 4,
    durability: [1000, 200],
    moveSpeed: 0,
    eitrRegen: 0.3,
  },

  {
    id: 'CapeAsksvin',
    tier: 7,
    type: 'armor', slot: 'shoulders',
    armor: [1, 1],
    weight: 4,
    maxLvl: 4,
    damageModifiers: { frost: 'resistant' },
    durability: [1500, 50],
    moveSpeed: 0,
    staminaModifiers: { dodge: -0.15 },
    effect: effectsById.WindRun,
  },
  {
    id: 'CapeAsh',
    tier: 7,
    type: 'armor', slot: 'shoulders',
    armor: [12, 2],
    weight: 4,
    maxLvl: 4,
    damageModifiers: { frost: 'resistant', fire: 'weak' },
    durability: [1200, 50],
    moveSpeed: 0,
    staminaModifiers: { attack: -0.1, block: -0.2 },
  },
  {
    id: 'TrinketFlametalEitr',
    tier: 7,
    type: 'armor', slot: 'trinket',
    armor: [0, 0],
    weight: 2,
    maxLvl: 1,
    durability: [Infinity, 0],
    moveSpeed: 0,
    adrenaline: {
      max: 70,
      effect: effectsById.TrinketFlametalEitr!,
    },
  },
  {
    id: 'TrinketFlametalStaminaHealth',
    tier: 7,
    type: 'armor', slot: 'trinket',
    armor: [0, 0],
    weight: 2,
    maxLvl: 1,
    durability: [Infinity, 0],
    moveSpeed: 0,
    adrenaline: {
      max: 85,
      effect: effectsById.TrinketFlametalStaminaHealth!,
    },
  },
  // non-systematic
  {
    id: 'HelmetSweatBand',
    tier: 0,
    type: 'armor', slot: 'head',
    hideHair,
    armor: [1, 1],
    weight: 1,
    maxLvl: 4,
    durability: [1000, 200],
    moveSpeed: 0,
  },
  {
    id: 'HelmetYule', season: 'christmas',
    tier: 0,
    type: 'armor', slot: 'head',
    hideHair,
    armor: [2, 0],
    weight: 1,
    maxLvl: 1,
    durability: [Infinity, 0],
    moveSpeed: 0,
  },
  {
    id: 'HelmetMidsummerCrown', season: 'midsummer',
    tier: 2,
    type: 'armor', slot: 'head',
    armor: [1, 0],
    weight: 1,
    maxLvl: 1,
    durability: [Infinity, 0],
    moveSpeed: 0,
  },
  {
    id: 'HelmetPointyHat', season: 'helloween',
    tier: 3,
    type: 'armor', slot: 'head',
    armor: [1, 2],
    weight: 3,
    maxLvl: 4,
    durability: [800, 100],
    moveSpeed: 0,
  },
  {
    id: 'HelmetFishingHat',
    tier: 6,
    type: 'armor', slot: 'head',
    armor: [8, 4],
    weight: 3,
    maxLvl: 4,
    durability: [1000, 200],
    moveSpeed: 0,
    effect: effectsById.SetEffect_FishingHat,
  },
  {
    id: 'HelmetDverger',
    tier: 2,
    type: 'armor', slot: 'head',
    special: 'light',
    armor: [0, 0],
    weight: 1,
    maxLvl: 1,
    durability: [Infinity, 0],
    moveSpeed: 0,
  },
  {
    id: 'BeltStrength',
    tier: 2,
    type: 'armor', slot: 'util',
    special: 'strength',
    armor: [0, 0],
    weight: 2,
    maxLvl: 1,
    durability: [Infinity, 0],
    moveSpeed: 0,
  },
  {
    id: 'Wishbone',
    PointLight: { color: '#39FF9C', range: 3, intensity: 1 },
    tier: 4,
    type: 'armor', slot: 'util',
    special: 'search',
    armor: [0, 0],
    weight: 0.1,
    floating: true,
    maxLvl: 1,
    durability: [Infinity, 0],
    moveSpeed: 0,
    stack: 1,
  },
  {
    id: 'Demister',
    PointLight: { color: '#7BCDFF', range: 10, intensity: 1.5 },
    tier: 6,
    type: 'armor', slot: 'util',
    floating: true,
    special: 'demister',
    armor: [0, 0],
    weight: 0.1,
    maxLvl: 1,
    durability: [Infinity, 0],
    moveSpeed: 0,
  },
  {
    id: 'HelmetOdin',
    dlc: 'beta',
    tier: 0,
    type: 'armor', slot: 'head',
    hideHair,
    armor: [1, 0],
    weight: 1,
    maxLvl: 1,
    durability: [300, 0],
    moveSpeed: 0,
  },
  {
    id: 'CapeOdin',
    dlc: 'beta',
    tier: 0,
    type: 'armor', slot: 'shoulders',
    armor: [2, 0],
    weight: 4,
    maxLvl: 1,
    durability: [1500, 0],
    moveSpeed: 0,
  },
  {
    id: 'CapeTest',
    tier: -1,
    disabled: true,
    type: 'armor', slot: 'shoulders',
    armor: [1, 1],
    weight: 4,
    maxLvl: 4,
    durability: [100, 50],
    moveSpeed: 0,
  },
  /*
  GoblinBrute_Backbones       head
  GoblinBrute_ExecutionerCap  head
  GoblinBrute_ArmGuard        body
  GoblinBrute_HipCloth        legs
  GoblinBrute_LegBones        util
  GoblinBrute_ShoulderGuard   shoulders
  GoblinHelmet                body
  GoblinLegband               ???
  GoblinLoin                  ???
   */
];

for (const item of items) {
  if (item.components == null) item.components = [];
  item.components.push('ItemDrop');
}
